import React, { useEffect, useState, useRef } from 'react';
import Typography from '@mui/material/Typography';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary, { accordionSummaryClasses } from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';


const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': { borderBottom: 0 },
  '&::before': { display: 'none' },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ color: 'white', fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]: {
    transform: 'rotate(90deg)',
  },
  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
  color: 'white',
}));

function CustomizedAccordions({ folder, showLength = true }) {
    const [expanded, setExpanded] = useState(false);
    const [documents, setDocuments] = useState([]);
    const panelRefs = useRef([]);
    const summaryRefs = useRef([]);



  const getChipProps = (contentLength) => {
    if (contentLength < 1200) return { color: 'success', label: 'S' };
    if (contentLength < 3000) return { color: 'warning', label: 'M' };
    return { color: 'error', label: 'L' };
  };

  const handleChange = (panel) => (event, newExpanded) => { setExpanded(newExpanded ? panel : false) };

  useEffect(() => {
  if (expanded !== false) {
    const index = parseInt(expanded.replace('panel', ''));
    const summaryRef = summaryRefs.current[index];
    if (summaryRef) {
      summaryRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}, [expanded]);



  useEffect(() => {
    const loadDocuments = async () => {
      try {
        const indexRes = await fetch(`/${folder}/index.json`);
        const fileList = await indexRes.json(); // ['doc1.txt', 'doc2.txt']

        const loadedDocs = await Promise.all(
          fileList.map(async (filename) => {
            const res = await fetch(`/${folder}/${filename}`);
            const text = await res.text();

            const titleMatch = text.match(/titolo:\s*(.*)/i);
            const contentMatch = text.match(/contenuto:\s*([\s\S]*)/i);

            return {
              title: titleMatch?.[1]?.trim() || filename,
              content: contentMatch?.[1]?.trim() || '',
            };
          })
        );

        setDocuments(loadedDocs);
      } catch (error) {
        console.error(`Errore durante il caricamento da "${folder}":`, error);
      }
    };

    loadDocuments();
  }, [folder]); // si aggiorna quando cambia la cartella

  return (
    <div>
      {documents.map((doc, index) => (
  <Accordion
  key={index}
  ref={(el) => (panelRefs.current[index] = el)}
  expanded={expanded === `panel${index}`}
  onChange={handleChange(`panel${index}`)}
  sx={{ backgroundColor: 'rgba(52, 0, 0, 0.14)', boxShadow: 'none' }}
>
  <AccordionSummary
    ref={(el) => (summaryRefs.current[index] = el)}
    sx={{ color: 'white' }}
  >
    <Typography component="span">{doc.title}</Typography>
    {showLength && (
      <Chip
        {...getChipProps(doc.content.length)}
        variant="outlined"
        size="small"
        sx={{ ml: 1 }}
      />
    )}

  </AccordionSummary>

          <AccordionDetails>
            <Typography
              sx={{
                whiteSpace: 'pre-wrap',  // preserva i ritorni a capo
                wordBreak: 'break-word',
              }}
            >
              {doc.content}
            </Typography>
          </AccordionDetails>

        </Accordion>
      ))}
    </div>
  );
}


export default CustomizedAccordions;
